import React, { useEffect, useState } from "react";
import { http } from "../../utils/http";
import FilledTimeslots from "./FilledTimeslots";
import EmptyTimeslots from "./EmptyTimeslots";
import renderIf from "render-if";

const TimeslotsComponent = ({ salonID, selectedDate, handleChange }) => {
  const [data, setData] = useState([]);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    setIsError(false);
    http
      .get(`api/slots/${salonID}/?date=${selectedDate}`)
      .then((result) => {
        setData(result.data[0].data[`${selectedDate}`]);
        setIsError(false);
      })
      .catch((error) => {
        setIsError(true);
      });
  }, [selectedDate, salonID]);

  return (
    <>
      {renderIf(isError === false)(
        <FilledTimeslots timeslots={data} handleChange={handleChange} />
      )}
      {renderIf(isError === true)(<EmptyTimeslots />)}
    </>
  );
};

export default TimeslotsComponent;
